<template>
  <div class="div-conteudo">
    <transition name="modal" v-if="carregando"></transition>

    <div class="wrapper" v-else-if="formulario">
      <div class="topo-header centro">
        <botao-voltar nomeRota="Formularios" />
        <h1>{{ formulario.titulo }}</h1>        
      </div>
      
      <div class="centro">
        <p>Visualizar Respostas</p>
      </div>

      <div class="form centro">
        <MsgErroFormularios
          v-if="erroApi"
          :mensagens="{ api: erroApi }"
          :erro="!!erroApi"
          @fechar-erro="erroApi = null"
        />

        <h2 @click="alternarFormulario" class="titulo-toggle">
          Exibir Formulário
          <span class="icone-toggle">{{ mostrarFormulario ? '▼' : '▶' }}</span>
        </h2>

        <div class="caixa-form fade-in" v-if="mostrarFormulario">
            <div class="perguntas-lista">
              <div 
                v-for="(pergunta_formulario, index) in formulario.perguntas_formulario" 
                :key="pergunta_formulario.id" 
                class="pergunta-item"
              >
                <p class="pergunta-titulo">
                  <strong>{{ index + 1 }}. {{ pergunta_formulario.pergunta.texto }}</strong>
                </p>
                
                <p class="pergunta-detalhe">
                  Tipo: <span>{{ formatarTipoPergunta(pergunta_formulario.tipo_pergunta) }}</span>
                </p>

                <div v-if="(pergunta_formulario.tipo_pergunta === 'escolha_unica' || pergunta_formulario.tipo_pergunta === 'multipla_escolha') && pergunta_formulario.alternativas.length > 0">
                  <p class="alternativas-titulo">Alternativas:</p>
                  <ul class="alternativas-lista">
                    <li 
                      v-for="alternativa in pergunta_formulario.alternativas" 
                      :key="alternativa.id" 
                      class="alternativa-item"
                    >
                      {{ alternativa.resposta.texto }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div class="pergunta-item" style="margin-top: 1rem;">
              <p class="pergunta-titulo">
                <strong>{{ formulario.perguntas_formulario.length + 1 }}. Observações</strong>
              </p>
              <p class="pergunta-detalhe">
                <span>Campo Discursivo (Opcional)</span>
              </p>
            </div>           
        </div>
        
        <br>
        
        <ListaRespondentes 
          v-if="respondentes.length > 0 && usuarioLogado" 
          :respondentes="respondentes" 
          :formulario-id="id"
          :usuario-logado-id="usuarioLogado.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormularioApi from "../../services/FormularioApi";
import BotaoVoltar from "../../components/BotaoVoltar.vue";
import ListaRespondentes from "../../components/formularios/ListaRespondentes.vue";
import MsgErroFormularios from "../../components/MsgErroFormularios.vue";
import HomeApi from "../../services/HomeApi";

export default {
  name: "VisualizarRespostaFormulario",
  metaInfo() {
    return {
      title: "Visualizar Formulário", 
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
    };
  },
  props: {
    id: { type: [String, Number], required: true },
  },
  components: { BotaoVoltar, ListaRespondentes, MsgErroFormularios },
  data() {
    return {
      carregando: true,
      formulario: null,
      respondentes: [],
      erroApi: null,
      usuarioLogado: null,
      
      mostrarFormulario: false, 
    };
  },
  created() {
    this.formularioApi = new FormularioApi();
    this.homeApi = new HomeApi();
    this.carregarDadosDaPagina();
  },

  methods: {
    alternarFormulario() {
      this.mostrarFormulario = !this.mostrarFormulario;
    },

    // Adicionado este método que veio do ExibirFormulario.vue
    formatarTipoPergunta(tipo) {
      if (!tipo) return '';
      switch (tipo) {
        case 'escolha_unica':
          return 'Escolha única';
        case 'multipla_escolha':
          return 'Múltipla escolha';
        case 'discursiva':
          return 'Discursiva';
        default:
          return tipo.charAt(0).toUpperCase() + tipo.slice(1);
      }
    },

    async carregarDadosDaPagina() {
      this.carregando = true;
      try {
        const [dadosFormulario, dadosRespondentes, dadosUsuarioLogado] = await Promise.all([
          this.formularioApi.getFormulario(this.id),
          this.formularioApi.getRespondentes(this.id),
          this.homeApi.getUsuarioAtual()
        ]);
       
        this.formulario = dadosFormulario;
        this.respondentes = dadosRespondentes;
        this.usuarioLogado = dadosUsuarioLogado;

      } catch (err) {
        console.error("Erro ao carregar dados da página:", err);
        this.erroApi = "Falha ao carregar os dados do formulário.";
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 1.5rem;
}
.caixa-form {
  background-color: #f0f0f0;
  padding: 1.5rem;
  border-radius: 8px;
}

/* === ESTILOS DA SESSÃO (TOGGLE) === */
.titulo-toggle {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  
  background-color: #e0e0e0; 
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  
  color: #005516;
  font-family: "Montserrat-Bold";
  font-size: 1.2rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: #d4d4d4;
  }
}

.icone-toggle {
  font-size: 1.2em;
  color: #ffa600; 
  margin-left: 10px;
}

.fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}

/* === NOVOS ESTILOS (Vindos do ExibirFormulario) === */
.perguntas-lista {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.pergunta-item {
  background-color: #fff; /* Fundo branco para destacar no fundo cinza da caixa */
  padding: 1rem;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.pergunta-titulo {
  font-size: 1.1rem;
  margin: 0;
  color: #000;
}

.pergunta-detalhe {
  font-size: 0.9rem;
  color: #555;
  margin: 0.5rem 0 0 0;
  text-transform: capitalize;
}

.pergunta-detalhe span {
  font-weight: bold;
}

.alternativas-titulo {
  font-weight: bold;
  font-size: 0.95rem;
  color: #333;
  margin: 1rem 0 0.5rem 1rem;
}

.alternativas-lista {
  list-style-type: disc;
  margin: 0.5rem 0 0 2.5rem;
  padding: 0;
}

.alternativa-item {
  font-size: 0.9rem;
  color: #444;
  margin-bottom: 0.5rem;
}
</style>